import React, { useEffect, useState } from "react";
import type { CollapseProps } from "antd";
import { Collapse } from "antd";
import s from "./FilterPopOver.module.scss";
import clsx from "clsx";
type PropType = {
  status: "active" | "revoked" | "disabled" | undefined;
  setStatus: (status: "active" | "revoked" | "disabled" | undefined) => void;
};
function FilterPopOverContent({ setStatus, status }: PropType) {
  const [activeKey, setActiveKey] = useState<string>("1");
  const [statusDraft, setDraftStatus] = useState<
    "active" | "revoked" | "disabled"
  >();
  const items: CollapseProps["items"] = [
    {
      key: "1",
      label: "Status",
      children: (
        <div className={clsx(s.options, { [s.active]: activeKey === "1" })}>
          <p
            className={clsx(s.option, {
              [s.active]: statusDraft === "active",
            })}
            onClick={() => setDraftStatus("active")}
          >
            Active
          </p>
          <p
            className={clsx(s.option, {
              [s.active]: statusDraft === "disabled",
            })}
            onClick={() => setDraftStatus("disabled")}
          >
            Disabled
          </p>
          <p
            className={clsx(s.option, {
              [s.active]: statusDraft === "revoked",
            })}
            onClick={() => setDraftStatus("revoked")}
          >
            Revoked
          </p>
        </div>
      ),
    },
  ];
  const onChange = (key: string | string[]) => {
    if (Array.isArray(key)) {
      // collapse closed (empty array), reset state
      setActiveKey(key[0]);
    } else {
      setActiveKey(key);
    }
  };
  const handleRest = () => {
    setDraftStatus(undefined);
    setStatus(undefined);
  };
  const handleApply = () => {
    setStatus(statusDraft);
  };
  useEffect(() => {
    setDraftStatus(status);
  }, [status]);

  return (
    <div className={s.wrapper}>
      <Collapse items={items} accordion ghost onChange={onChange} />
      <div className={s.btnWrapper}>
        <button className={s.resetBtn} onClick={handleRest}>
          Reset
        </button>
        <button className={s.applyBtn} onClick={handleApply}>
          Apply
        </button>
      </div>
    </div>
  );
}

export default FilterPopOverContent;
